// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__1aze9","active":"NavigationItem_active__3a9D6"};